import { useGetExamCenterMemberByIdQuery } from '@exam-center/graphql';
import { useMemo } from 'react';

import { ExamCenterMemberDetailsModalView } from '../../components';
import { mapExamCenterMemberData } from '../../utils';
import { UserAvatar } from '../user-avatar';

interface ExamCenterMemberDetailsModalProps {
  open: boolean;
  onClose: () => void;
  examCenterMemberId: string;
}

export default function ExamCenterMemberDetailsModal(
  props: Readonly<ExamCenterMemberDetailsModalProps>,
) {
  const { open: isOpen, onClose, examCenterMemberId } = props;

  const { data: examCenterMemberData, loading: isLoading } = useGetExamCenterMemberByIdQuery({
    skip: examCenterMemberId === '',
    variables: {
      getExamCenterMemberByIdInput: {
        examCenterMemberId: examCenterMemberId,
      },
    },
  });

  const examCenterMember = useMemo(() => {
    return mapExamCenterMemberData(
      examCenterMemberData?.ecGetExamCenterMemberById.examCenterMember,
    );
  }, [examCenterMemberData]);

  return (
    <ExamCenterMemberDetailsModalView
      open={isOpen}
      onClose={onClose}
      examCenterMember={examCenterMember}
      avatar={<UserAvatar fullName={examCenterMember.fullName} email={examCenterMember.email} />}
      isLoading={isLoading}
    />
  );
}
